export function removeDash(string) {
  return string.replace(/-/g, " ")
}
